<app-base-card>
  <ng-container
    *ngFor="let food of dishItems; last as isLast; first as isFirst"
  >
    <article
      [ngStyle]="{ opacity: parseNumber(food?.stockCount) > 0 ? '1' : '0.4' }"
      class="dish-item card border-0"
      (click)="food?.stockCount !== 0 && selectItem(food)"
      [ngClass]="{'cursor-not-allowed': food?.stockCount === 0}"
    >
      <div
        class="row no-gutters align-items-center mb-3 px-3"
        [ngClass]="{
          'border-bottom': !isLast,
          'p-3': isFirst,
          'pt-0 pb-3': !isFirst && !isLast
        }"
      >
        <div class="col-4">
          <div class="dish-img-container position-relative">
            <img
              *ngIf="isImageValid(food?.imageUrl)"
              [src]="food?.imageUrl"
              [alt]="food?.name"
            />
            <img
              *ngIf="!isImageValid(food?.imageUrl)"
              src="/assets/images/no-food-img.svg"
              [alt]="food?.name"
            />
          </div>
        </div>
        <div class="col-8 pl-3">
          <div class="d-flex justify-content-between align-items-center">
            <p class="secondary-font-medium mb-0">
              {{ food?.name }}
            </p>
            <span 
              *ngIf="food?.stockCount === 0"
              class="bg-danger text-white px-2 py-1 f-12 primary-font-normal"
            >
              Out of Stock
            </span>
          </div>
          <p
            *ngIf="food?.description"
            class="f-14 primary-font-normal text-gray-500 my-2"
          >
            <ng-container *ngIf="food?.description?.length < 50">
              {{ food?.description }}
            </ng-container>
            <ng-container *ngIf="food?.description?.length > 50">
              {{ food?.description | slice : 1 : 80 }}...
            </ng-container>
          </p>
          <div class="d-flex flex-row align-items-center">
            <img
              *ngIf="food?.duration"
              src="/assets/icons/clock.svg"
              alt="time"
            />
            &nbsp;
            <span *ngIf="food?.duration" class="primary-font-bold f-14">
              {{ food?.duration }} mins
            </span>
            &nbsp; &#x2022; &nbsp;
            <span *ngIf="food?.price" class="primary-font-bold f-14">
              {{ food?.price | currency : '₦' }}
            </span>
          </div>
        </div>
      </div>
    </article>
  </ng-container>
</app-base-card>
